export default function getCurrencyReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'GETS_CURRENCY_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GETS_CURRENCY_ERROR':
            return {...state, ...{error: action.error}};

        case 'GETS_CURRENCY_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}